import React from 'react';
import { CardContent, Stack } from '@mui/material';
import { useAppSelector } from '../../../../app/hooks';
import {
  IdentificationSection,
  FacilitySection,
  ScheduleSection,
  CompletionTrackingSection,
  DocumentUploadsSection,
  NotesSection,
  ChecklistItemsSection,
} from './sections';

/**
 * ComplianceEditForm - Main form container for compliance item editing
 * Reuses the create form's Identification/Schedule/Notes sections; renders Facility read-only
 * because the center is the Cosmos partition key and is immutable after creation (research.md #2).
 * Renders the EOC round Checklist Items section only for EnvironmentOfCare requirements
 * (data-model.md: `ChecklistItems` is empty for every non-EOC requirement).
 */
export const ComplianceEditForm: React.FC = () => {
  const { currentComplianceItem } = useAppSelector(state => state.compliance);
  const isEocItem = currentComplianceItem?.complianceType === 'EOC';

  return (
    <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
      <Stack spacing={2.5}>
        <FacilitySection readOnly />
        <IdentificationSection />
        <ScheduleSection />
        <CompletionTrackingSection />
        {isEocItem && <ChecklistItemsSection />}
        <NotesSection />
        <DocumentUploadsSection />
      </Stack>
    </CardContent>
  );
};

export default ComplianceEditForm;

